import { useTranslation } from 'next-i18next'
import { OutOfStockBadge } from 'components/event/RaceCard/RaceCard.style'

interface RacePageBadgeProps {
  remainingStock: number | null
}

const RacePageBadge = ({ remainingStock }: RacePageBadgeProps) => {
  const { t } = useTranslation('common')
  const isOutOfStock = remainingStock ? remainingStock <= 0 : true
  const badgeContent = isOutOfStock
    ? t('OUT_OF_STOCK')
    : `${remainingStock} ${
        remainingStock && remainingStock > 1
          ? t('AVAILABLE.multiple')
          : t('AVAILABLE.single')
      }`
  return <OutOfStockBadge>{badgeContent}</OutOfStockBadge>
}

export default RacePageBadge
